<template> 
  <div id="page-user-list">
    <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"  @click="$router.push('/reception-add')">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Add New</span>
      </div>
    </div>
    <div class="vx-card p-6" style="position: relative;">
      <transition name="fade">
        <div v-if="isRestoringFilters" class="filter-loading-overlay" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.5); z-index: 10; display: flex; align-items: center; justify-content: center; border-radius: 8px; pointer-events: none;">
          <div style="display: flex; align-items: center; gap: 8px; color: #7367f0; opacity: 0.8;">
            <div class="spinner" style="width: 16px; height: 16px; border: 2px solid rgba(115, 103, 240, 0.2); border-top-color: #7367f0; border-radius: 50%; animation: spin 0.6s linear infinite;"></div>
            <span style="font-size: 12px; font-weight: 500;">Restoring filters...</span>
          </div>
        </div>
      </transition>
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ operationsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : operationsData.length }} of {{ operationsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <vs-button v-if="displayExport != false" class="mb-4 md:mb-0 mr-2" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
          <div v-if="hasActiveFilters" class="flex items-center mr-2 mb-4 md:mb-0">
            <span class="text-sm font-medium" style="color: #7367f0;">
              <feather-icon icon="Filter" svgClasses="h-4 w-4 inline mr-1" />
              Filters active
            </span>
          </div>
          <vs-button type="border" color="primary" class="mb-4 md:mb-0" @click="clearAllFilters" icon-pack="feather" icon="icon-x">
            Clear Filters
          </vs-button>

          <!-- ACTION - DROPDOWN -->
<!--
          <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
-->
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="operationsData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleOperationList from '@/store/operation/moduleOperationList.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'


export default {
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data () {
    return {
      alreadyajusted: false,
      displayExport: false,
     searchQuery: '',
     filterChangeCounter: 0, // Pour forcer la réactivité du computed hasActiveFilters
     isRestoringFilters: false,

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: '#',   
          valueGetter: function(params) {
            return '#'+params.data.nameorid
          },
          //field: 'iscompany',
          filter: true,
          width: 130,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Date',   
          valueGetter: function(params) {
            return params.data.creation
          },
          //field: 'iscompany',
          sort:'DESC',
          filter: true,
          width: 135
        },
        {
          headerName: 'Supplier',
          field: 'client',
          filter: true,
          width: 150
        },
        {
          headerName: 'Volume (m3)',
          valueGetter: function(params) {
            if (params.data.volume) return Math.abs(Math.abs(params.data.volume).toFixed(1))
            else return "-"
          },
          filter: true,
          width: 145,
          type: 'numericColumn'
        },
        {
          headerName: 'Cost (EUR)',
          valueGetter: function(params) {
            if (params.data.price) return Math.abs(Math.abs(params.data.price).toFixed(2))
            else return "-"
          },
          filter: true,
          width: 145,
          type: 'numericColumn'
        },
        {
          headerName: '(EUR/m3)',
          valueGetter: function(params) { 
            if (params.data.price && params.data.volume) return Math.abs(Math.abs(params.data.price).toFixed(2)/Math.abs(params.data.volume).toFixed(4)).toFixed(2)
            else return "-"
          },
          filter: true,
          width: 145,
          type: 'numericColumn'
        },
        {
          headerName: 'Weight (tons)',
          valueGetter: function(params) {
            if (params.data.weight) return Math.abs(params.data.weight).toFixed(2)
            else return "-"
          },
          filter: true,
          width: 145,
          type: 'numericColumn'
        },
        {
          headerName: 'Internal Note',
          valueGetter: function(params) {
            let val = ""
            if (params.data.internal_note) val = params.data.internal_note
            if (params.data.apv_no) val = val+ "APV "+params.data.apv_no
            if (params.data.sumal_aviz_nr) val = val+ "AVIZ "+params.data.sumal_aviz_nr
            return val
          },
          filter: true,
          width: 410,
          cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'Actions',
          field: 'transactions',
          width: 120,
          cellRendererFramework: 'CellRendererActions'
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  computed: {
    operationsData () {
      return this.$store.state.operationList.operations
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 100
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    hasActiveFilters() {
      // Utiliser filterChangeCounter pour forcer la réactivité
      const _ = this.filterChangeCounter;
      if (!this.gridApi) return false;
      const filterModel = this.gridApi.getFilterModel();
      const hasColumnFilters = filterModel && Object.keys(filterModel).length > 0;
      const hasSearchFilter = this.searchQuery && this.searchQuery.trim() !== '';
      return hasColumnFilters || hasSearchFilter;
    },
  },
  methods: {
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
      // Forcer la mise à jour du computed
      this.filterChangeCounter++
    },
    clearAllFilters() {
      // Réinitialiser tous les filtres
      if (this.gridApi) {
        this.gridApi.setFilterModel(null);
        this.gridApi.setQuickFilter('');
        this.searchQuery = '';
        this.gridApi.onFilterChanged();
        // Forcer la mise à jour
        this.filterChangeCounter++;
      }
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api

    // Ajouter un listener pour les changements de filtres
    if (this.gridApi) {
      this.gridApi.addEventListener('filterChanged', () => {
        // Incrémenter le compteur pour forcer la réactivité du computed hasActiveFilters
        this.filterChangeCounter++
      })
    }

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  }, 
  created () {
    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    } 
    this.$vs.loading()
    
    if (localStorage.getItem('login-roles').toLowerCase().includes("admin")) {
      this.displayExport = true
    }
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule('operationList', moduleOperationList)
      moduleOperationList.isRegistered = true
    }
    this.$store.dispatch('operationList/fetchReceptions')
    .then(response => {
      this.$vs.loading.close()
    })
    .catch(err => { console.error(err) })
  }
}

</script>

<style lang="scss">
@keyframes spin {
  to { transform: rotate(360deg); }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
